//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.VehicleDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../Features/Features.SelectFeature.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[0,"EyeFeature",1,"Features.Feature",0],[1,"Eyellipse",0,"Features.SelectFeature",0],[0,"EyellipsePercentile",1,0],[0,"FixedSideGlazing",1,0],[0,"ForwardGlazing",1,0],[0,"ForwardGlazingGeometry",1,"ScCollector",0],[0,"Loading",1,0],[0,"RearGlazing",1,0],[0,"RearGlazingGeometry",1,"ScCollector",0],[0,"SideGlazingGeometry",1,"ScCollector",0],[0,"UpperPoint",1,"Point",0],[0,"UseStandardLoading",1,0],[0,"UseViewHeight",1,0],[0,"ViewHeight",1,1],[1,"ViewHeightExp",0,"Expression",0]],[],[]];
SPLM.Features.VehicleDesign.GlazingShadeBandsBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.VehicleDesign.GlazingShadeBandsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.VehicleDesign.GlazingShadeBandsBuilder.EyePercentile = Object.freeze({
    "Per95" : "Per95", "Per99" : "Per99"});

export default SPLM;